const sigla = (texto?: string | null, literal_sigla?: string | null): string => {
  if (literal_sigla) return literal_sigla;
  if (!texto) return '';

  const parts = texto.split(' ');
  let initials = '';

  for (let i = 0; i < parts.length; i++) {
    if (parts[i].length > 2 && parts[i] !== '') {
      initials += parts[i][0];
    }
  }

  return initials;
};

export { sigla };
